var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loading-overlay"},[_c('section',{staticClass:"centered-container"},[_c('img',{staticClass:"imgSty",attrs:{"src":require("@/assets/img/Loading.gif")}}),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }